import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ModalController, AlertController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { TranslateService } from '@ngx-translate/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AuthServices } from '../../auth/services';
import { TPVServices } from '../../tpv/services';

/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-users',
  templateUrl: 'configuration-users.html',
})
export class ConfigurationUsersPage {
  loading: any;
  showSpinner: boolean = true;
  showEdit: boolean = false;
  showCreate: boolean = false;
  access_fields: any = [
    {
      name: this.translate.instant('general-articulos'),
      name_bbdd: 'articles',
      active: false
    },
    {
      name: this.translate.instant('config-web-cartas-menus'),
      name_bbdd: 'menus',
      active: false
    },
    {
      name: 'POS',
      name_bbdd: 'pos',
      active: false
    },
    {
      name: this.translate.instant('general-comandero'),
      name_bbdd: 'orders',
      active: false
    },
    {
      name: 'KDS',
      name_bbdd: 'kds',
      active: false
    },
    {
      name: this.translate.instant('general-pedidos-online'),
      name_bbdd: 'takeaway',
      active: false
    },
    {
      name: this.translate.instant('general-reservas'),
      name_bbdd: 'reservations',
      active: false
    },
    {
      name: this.translate.instant('general-stock'),
      name_bbdd: 'stock',
      active: false
    },
    {
      name: this.translate.instant('general-informes') + '/' + this.translate.instant('general-analitica'),
      name_bbdd: 'analytics',
      active: false
    },
    /*{
      name: 'Configuración',
      name_bbdd: 'configuration',
      active: false
    },*/
    {
      name: this.translate.instant('config-users-administrador'),
      name_bbdd: 'admin',
      active: false
    },
    {
      name: 'Printer',
      name_bbdd: 'printer',
      active: false
    }
  ];
  //limits
  enable_create_user: boolean = false;
  limit_users: boolean = true;
  //form
  user_auth_uid: string = '';
  user_uid: string = '';
  user_name: string = '';
  user_rol: string = '';
  user_email: string = '';
  user_pass: string = '';
  user_pass_repeat: string = '';
  user_access: any = [];
  pass_placeholder: string = "**********";

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public http: HttpClient,
    public authServices: AuthServices,
    public tpvServices: TPVServices) {

    this.globals.getUsersFromNode();
    this.globals.GAtrackView('Configuration', 'Configuration - Users - View ', this.globals.restaurant.email, 'View', 'List users', 'Configuration', '');
  }

  ionViewWillEnter() {
    //this.getUsers();
  }

  ionViewDidLeave() {
    var from = this.navParams.get('from');
    if (from && from === 'tpv') {
      this.tpvServices.menu_select_room = 'room';
      this.globals.side_menu_active = 'tpv';
    }
  }

  getNameAccess(access) {
    if (access) {
      var _return = '';
      for (let rol of access) {
        _return += this.access_fields.filter(x => x.name_bbdd == rol).map(x => x.name) + ', ';
      }
      return _return.slice(0, -2);
    }
    return '';
  }

  getUsers() {
    this.enable_create_user = false;
    //this.globals.users = this.globals.users_array;
    if (this.globals.users == undefined || this.globals.users.length >= this.globals.checkLimitsByLicense('config', 'users') && this.globals.checkLimitsByLicense('config', 'users') != -1) {
      this.limit_users = false;
      this.enable_create_user = false;
    } else {
      this.limit_users = true;
      this.enable_create_user = true;
    }
    this.showSpinner = false;
    return this.enable_create_user
  }

  async edit(user) {
    await this.desactiveAccessFields();
    if (!user.disable) {
      this.showEdit = true;
      this.showCreate = false;
      //
      this.user_name = user.name;
      this.user_email = user.email;
      this.user_uid = user.uid;
      this.user_rol = this.globals.getOldRolFromNew(user.access);
      this.pass_placeholder = "**********";
      this.user_pass = '';
      this.user_pass_repeat = '';
      if (user.access) {
        this.access_fields.forEach(field => {
          if (user.access.includes(field.name_bbdd)) {
            field.active = true;
          }
        });
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async create() {
    await this.desactiveAccessFields();
    if (this.limit_users) {
      this.showCreate = true;
      this.showEdit = false;
      //
      this.user_name = '';
      this.user_email = '';
      this.user_uid = '';
      this.pass_placeholder = "";
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async editUser() {
    const { user_name, user_email, user_pass, user_pass_repeat } = this;
    this.user_access = this.access_fields.filter(x => x.active == true).map(x => x.name_bbdd);
    //Faltan datos
    if (!user_name) {
      this.globals.launchToast(this.translate.instant('instant-rellena-todos-campos-formulario'), 3000, 'top');
      return;
    }
    //Contraseñas no iguales
    if (user_pass != '' && user_pass !== user_pass_repeat) {
      this.globals.launchToast(this.translate.instant('config-users-create-contrasenas-no-iguales'), 3000, 'top');
      return;
    }
    //Contraseña corta
    if (user_pass != '' && user_pass.length < 7) {
      this.globals.launchToast(this.translate.instant('config-users-create-min-chars-contrasena'), 3000, 'top');
      return;
    }

    //Update user
    let index_user = this.globals.users.findIndex(x => x.uid === this.user_uid);
    if (index_user >= 0) {
      this.loading = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      this.loading.present();
      var _user = await this.configurationServices.getUser(user_email);
      //
      this.globals.users[index_user].name = user_name;
      this.globals.users[index_user].rol = this.globals.getOldRolFromNew(this.user_access);
      this.globals.users[index_user].access = this.user_access;
      //
      for (let key in _user.restaurants) {
        if (_user.restaurants[key].UID_RESTAURANT == this.globals.restaurant_uid) {
          _user.restaurants[key].rol = this.globals.getOldRolFromNew(this.user_access);
          _user.restaurants[key].access = this.user_access;
        }
      }
      if (user_pass != '') {
        //Update password
        const params = new HttpParams()
          .set('uid', this.globals.users[index_user].uid_auth)
          .set('password', user_pass);
        this.http.post(this.globals.analytics_path + 'users/update', params, {})
          .subscribe(res => { }, error => { });
      }
      this.configurationServices.afs.collection('users').doc(_user.UID).update({
        'email': user_email,
        'name': user_name,
        'restaurants': _user.restaurants,
      }).then(() => {
        //caso mismo usuario actualizar info
        if (this.globals.user_uid_auth === this.globals.users[index_user].uid_auth) {
          this.globals.user_name = user_name;
          this.globals.user_access = this.user_access;
        }
        this.loading.dismiss();
        this.globals.GAtrackView('Configuration', 'Configuration - User - Update', this.globals.restaurant.email, 'Create/Update', 'Update user', 'Configuration', user_email);
      }).catch(err => {
        this.loading.dismiss();
      });
      this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 3000, 'top');
      this.showCreate = false;
      this.showEdit = false;
    }
  }

  createUser() {
    const { user_name, user_email, user_pass, user_pass_repeat } = this;
    this.user_access = this.access_fields.filter(x => x.active == true).map(x => x.name_bbdd);
    //Faltan datos
    if (!user_name || !user_email || !user_pass || !user_pass_repeat) {
      this.globals.launchToast(this.translate.instant('instant-rellena-todos-campos-formulario'), 3000, 'top');
      return;
    }
    //Contraseñas no iguales
    if (user_pass !== user_pass_repeat) {
      this.globals.launchToast(this.translate.instant('config-users-create-contrasenas-no-iguales'), 3000, 'top');
      return;
    }
    //Contraseña corta
    if (user_pass.length < 7) {
      this.globals.launchToast(this.translate.instant('config-users-create-min-chars-contrasena'), 3000, 'top');
      return;
    }

    //Create user in firebase en node para evitar el login
    this.loading = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    this.loading.present();
    const params = new HttpParams()
      .set('email', user_email)
      .set('password', user_pass);
    this.http.post(this.globals.analytics_path + 'users/create', params, {})
      .subscribe(res => {
        if (res['uid_user']) {
          this.user_auth_uid = res['uid_user'];
          this.authServices.createUserRestaurantConfiguration(user_email, user_name, this.user_auth_uid, this.globals.restaurant_uid, this.globals.getOldRolFromNew(this.user_access), this.user_access);
          this.loading.dismiss();
          this.showCreate = false;
          this.showEdit = false;
        } else {
          this.addRestToUser(this.globals.getOldRolFromNew(this.user_access));
        }
      }, error => {
        this.loading.dismiss();
      });
  }

  async addRestToUser(rol_old) {
    //recuperar user
    var _user = await this.configurationServices.getUser(this.user_email);
    this.user_uid = _user.UID;
    this.user_auth_uid = _user.uid_user_auth;
    //comprovar que en el usuario no exista el restaurante
    var _existeix = false;
    for (let key in _user.restaurants) {
      if (_user.restaurants[key].UID_RESTAURANT == this.globals.restaurant_uid) {
        _existeix = true;
      }
    }
    //
    if (_existeix) {
      this.loading.dismiss();
      this.globals.launchToast(this.translate.instant('instant-usuario-tiene-rol-restaurante'), 3000, 'top');
    } else {
      var restaurants = _user.restaurants;
      //mirar ultim index
      var last_key = Object.keys(restaurants)[Object.keys(restaurants).length - 1];
      if (last_key == undefined) {
        last_key = '-1';//Iniciamos a 0 si esta undefined
      }

      restaurants[Number(last_key) + 1] = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'rol': rol_old,
        'access': this.user_access
      }

      //insertar rest
      this.configurationServices.afs.collection('users').doc(_user.UID).update({
        'restaurants': restaurants,
      }).then(() => {
        this.loading.dismiss();
        this.globals.launchToast(this.translate.instant('instant-usuario-creado-correctamente.'), 3000, 'top');
        this.globals.GAtrackView('Configuration', 'Configuration - User - Create ', this.globals.restaurant.email, 'Create/Update', 'Create user', 'Configuration', this.user_email);
        this.showCreate = false;
        this.showEdit = false;
        //update user_array
        this.globals.users.push({
          disable: false,
          email: this.user_email,
          name: this.user_name,
          rol: rol_old,
          access: this.user_access,
          uid: this.user_uid,
          uid_auth: this.user_auth_uid
        });
      });
    }
  }

  desactiveAccessFields() {
    // Desactivar todos los elementos
    this.access_fields.forEach(field => {
      field.active = false;
    });
  }

  askDeleteUser() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-usuario'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-usuario'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteUser();
          }
        }
      ]
    });
    alert.present();
  }

  async deleteUser() {
    const { user_email } = this;
    let index_user = this.globals.users.findIndex(x => x.uid === this.user_uid);
    if (index_user >= 0) {
      var _user = await this.configurationServices.getUser(user_email);
      //convert to array
      let arr = [];
      for (let k in _user.restaurants) {
        arr.push(_user.restaurants[k]);
      }
      //delete
      arr.splice(_user.key, 1);

      //create of array to object
      const obj = {};
      arr.forEach((item, index) => {
        obj[index] = item;
      })
      _user.restaurants = obj;

      //elimina de global users el usuario eliminado
      for (var i = this.globals.users.length - 1; i >= 0; --i) {
        if (this.globals.users[i].uid == _user.UID) {
          this.globals.users.splice(i, 1);
        }
      }

      //no hi ha res dins object reiniciar
      if (Object.keys(_user.restaurants).length == 0) {
        _user.restaurants = {};
      }

      //update para que quede eliminado

      this.configurationServices.afs.collection('users').doc(_user.UID).update({
        'restaurants': _user.restaurants,
      }).then(() => {
        this.showCreate = false;
        this.showEdit = false;
      });
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-users/configuration-users.ts